<template>
  <v-card outlined>
    <v-data-table
      :items="list"
      :headers="headers"
      :loading="loading"
      :items-per-page="1000"
      class="row-pointer"
      mobile-breakpoint="0"
      @click:row="rowClick"
    >
      <template #[`item.published`]="{ item }">
        <v-icon
          small
          :color="item.published ? 'success' : 'error'"
        >
          wifi
        </v-icon>
      </template>
      <template #[`item.createdDate`]="{ item }">
        {{ item.createdDate | normalDate }}
      </template>
      <template #[`item.unpaid`]="{ item }">
        <template v-if="item.unpaid">
          {{ item.unpaid | currency }}
        </template>
        <v-icon v-else> remove </v-icon>
      </template>
      <template #[`item.actions`]="{}">
        <v-icon>more_vert</v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'UsersList',
  data: () => {
    return {
      headers: [
        { text: 'Name', value: 'email' },
        { text: 'Created', value: 'createdDate' },
        { text: 'Status', value: 'plan' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      list: 'users/list'
    })
  },
  mounted() {
    this.$store.dispatch('users/reset');
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.SEARCH_USERS);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.SEARCH_USERS, (query) => {
      this.search(query);
    });
  },
  methods: {
    search(query) {
      this.loading = true;
      this.$store
        .dispatch('users/getUsers', query)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      this.$router.push({ path: `/users/${item.id}` });
    }
  }
};
</script>
